import {track} from '@amplitude/analytics-browser';

import AMPLITUDE_EVENT_TYPES from '../../consts/amplitude/amplitudeEventTypes';
import amplitude from './amplitude';

const trackAboutMyDeviceScreen = () => {
    amplitude.trackDeviceAndHolderEvent(AMPLITUDE_EVENT_TYPES.ABOUT_MY_DEVICE);
};

const trackUsageStatisticsScreen = () => {
    track(AMPLITUDE_EVENT_TYPES.USAGE_STATISTICS_VIEWED);
};

const trackTipsAndTutorialsScreen = () => {
    amplitude.trackDeviceEvent(AMPLITUDE_EVENT_TYPES.TIPS_AND_TUTORIALS_VIEWED);
};

const trackDevicesSettingsScreen = () => {
    amplitude.trackDeviceAndHolderEvent(AMPLITUDE_EVENT_TYPES.DEVICE_SCREEN_VIEWED);
};

const trackPauseModeGuideViewed = () => {
    amplitude.trackDeviceEvent(AMPLITUDE_EVENT_TYPES.PAUSE_MODE_GUIDE_VIEWED);
};

export default {
    trackAboutMyDeviceScreen,
    trackUsageStatisticsScreen,
    trackTipsAndTutorialsScreen,
    trackDevicesSettingsScreen,
    trackPauseModeGuideViewed,
};
